import styled from 'styled-components'

export const mediaQueries = {
  mobile: '@media screen and (max-width: 750px)',
  notMobile: '@media screen and (min-width: 751px)',
  notTablet: '@media screen and (min-width: 901px)',
  tablet: '@media screen and (max-width: 900px)',
  widescreen: '@media (min-width:992px) and (max-width: 12450px)',
}

export const colors = {
  background: '#1B1B1B',
  bg: '#F1EBE2',
  headings: '#010002',
  subhead: '#010002',
  body: '#010002',
  accents: '#E79B56',
  text: '#010002',
  black: '#010002',
  subheading: '#010002',
  red: '#F32E08',
  blue: '#006FC3',
  yellow: '#FFB902',
  green: '#0D9D63',
  lightYellow: '#f9efb9',
  pink: '#ffb5b5',

  pastelRed: '#FFC0BE',
  pastelLightRed: '#F6E3E3',
  pastelGreen: '#AED9C7',
  pastelLightGreen: '#D7F4EA',
  pastelBlue: '#AACBE4',
  pastelLightBlue: '#D1E7F3',
  pastelYellow: '#F6E1AA',
  pastelLightYellow: '#FFF0C9',
}

export const fonts = {
  photo_credit: 'Prompt',
  nav_bar: 'Prompt',
  ticket_body: 'Prompt',
  passport_body: 'Prompt',
  apply: 'American Typewriter',
  passport_headline: 'American Typewriter',
  story_headline: 'Amiri',
  section_headline: 'Amiri',
}

// export const DBHead = styled('div')`
//   width: 100%;
//   padding: 0.5em 0;
//   color: black;
//   font-family: 'Times New Roman';
//   font-weight: 700;
//   text-align: center;
//   text-transform: uppercase;
//   font-size: 18px;
//   border-bottom: 1px solid black;
// `;
